import { cn } from '@/lib/utils';

/**
 * The single Anaka loader: three brand-gradient dots orbiting a triangle
 * (echoes the "A"). Pure CSS (keyframes in index.css); frozen under
 * prefers-reduced-motion. Used across every working auth state.
 */
export function AnakaTriDots({ size = 84, className }: { size?: number; className?: string }) {
  return (
    <div
      className={cn('anaka-tri', className)}
      style={{ width: size, height: size }}
      role="status"
      aria-label="Loading"
    >
      <span className="anaka-tri-dot" />
      <span className="anaka-tri-dot" />
      <span className="anaka-tri-dot" />
    </div>
  );
}
